var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.697,
    height: 33.134,
    viewBox: "0 0 41.697 33.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 3.9,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac192c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(0 -52.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4746",
    "data-name": "Trazado 4746",
    d: "M208.584,233.109a4.239,4.239,0,1,0,4.2,4.239A4.238,4.238,0,0,0,208.584,233.109Z",
    transform: "translate(-187.735 -165.815)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4747",
    "data-name": "Trazado 4747",
    d: "M40.507,59.736a4.065,4.065,0,0,0-2.889-1.206H33.2a.92.92,0,0,1-.84-.555l-1.322-2.96a4.078,4.078,0,0,0-3.722-2.422H14.377a4.082,4.082,0,0,0-3.723,2.422h0L9.332,57.972a.92.92,0,0,1-.84.555H4.078A4.087,4.087,0,0,0,0,62.629v19a4.11,4.11,0,0,0,1.188,2.894,4.066,4.066,0,0,0,2.89,1.2H37.618a4.058,4.058,0,0,0,2.888-1.2,4.1,4.1,0,0,0,1.192-2.9v-19a4.1,4.1,0,0,0-1.191-2.891ZM38.544,81.625a.949.949,0,0,1-.275.674.916.916,0,0,1-.65.272H4.078a.908.908,0,0,1-.65-.272.95.95,0,0,1-.275-.674v-19a.95.95,0,0,1,.275-.674.9.9,0,0,1,.65-.272H8.492a4.079,4.079,0,0,0,3.721-2.422L13.532,56.3a.93.93,0,0,1,.845-.555H27.324a.928.928,0,0,1,.844.553l1.318,2.961A4.077,4.077,0,0,0,33.2,61.681h4.413a.908.908,0,0,1,.65.272.952.952,0,0,1,.275.674v19Z",
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4748",
    "data-name": "Trazado 4748",
    d: "M151.873,170.938a9.17,9.17,0,0,0-6.532,2.725,9.352,9.352,0,0,0,0,13.147,9.18,9.18,0,0,0,13.063,0,9.352,9.352,0,0,0,0-13.147,9.171,9.171,0,0,0-6.531-2.725Zm4.808,14.167a6.755,6.755,0,0,1-9.616,0,6.925,6.925,0,0,1,0-9.73,6.755,6.755,0,0,1,9.616,0,6.922,6.922,0,0,1,0,9.73Z",
    transform: "translate(-131.024 -108.707)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9615",
    "data-name": "Rect\\xE1ngulo 9615",
    width: 2.802,
    height: 2.802,
    transform: "translate(31.94 64.407)",
    fill: "url(#radial-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2de90a9643a92bc09e1d76592d3d6466.svg";
export { ForwardRef as ReactComponent };